module.exports = __webpack_public_path__ + "img/create-memo-icon-white.46b21314.png";